import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import BasePage from './BasePage';
import reportWebVitals from './reportWebVitals';
//import Header from './components/Header/Header';
//import Main from './components/Main/Main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
    <BasePage />
  </React.StrictMode>
);

/* root.render(
  <React.StrictMode>
    <Header />
    <Main />
  </React.StrictMode>
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
